<template>
  <div
    class="px-6 py-8 bg-tripadvisor-green-light"
  >
    <h4
      data-i18n="tripadvisorTitle"
      class="whitespace-pre-line"
    >
      {{ toUnixNewlines($t('tripadvisorTitle')) }}
    </h4>
    <div
      v-if="data"
      ref="tripadvisor"
      class="flex flex-wrap -mx-8 pb-8"
    >
      <div class="md:w-4/12 px-8">
        <div class="flex items-center mb-2">
          <TripAdvisorRating
            :rating="data?.rating"
            :review-count="data?.num_reviews"
            type="dots"
            show-review-count
            empty-dots
          />
        </div>
        <div
          v-for="(award, award_index) in data?.awards"
          :key="`aW_${award_index}`"
          class="tripadvisor-award mt-4"
        >
          <img :src="washUrl(award?.images?.small)" />
          <span class="ml-2">
            {{ award?.display_name }}
          </span>
        </div>
      </div>
      <div class="w-full md:max-w-60 px-8 mt-6 md:mt-0">
        <div
          v-for="subrating in data?.subratings"
          :key="subrating?.name"
          class="flex"
        >
          <small class="rating-span">
            {{ subrating?.localized_name }}
          </small>
          <img
            class="ml-auto"
            :src="washUrl(subrating?.rating_image_url)"
            :alt="subrating?.value"
          />
        </div>
      </div>
      <div class="grow px-8 mt-8 md:mt-0">
        <table
          v-if="data?.review_rating_count"
        >
          <tr
            v-for="n in [1, 2, 3, 4, 5].reverse()"
            :key="n"
          >
            <td>
              {{ n }}
            </td>
            <td
              width="100%"
              class="px-2"
            >
              <div class="relative size-full h-5 -mt-0.5">
                <div
                  class="rounded-3xl h-full absolute top-0 bg-tripadvisor-green z-[1]"
                  :style="{ width: percentage(data?.review_rating_count[n], data?.num_reviews) + '%' }"
                />
                <div
                  class="rounded-3xl h-full bg-gray-300 w-full absolute top-0"
                />
              </div>
            </td>
            <td>
              {{ data?.review_rating_count[n] }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    percentage (curr, total) {
      return (100 * parseFloat(curr)) / parseFloat(total)
    },

    washUrl (url) {
      return (url || '').replace('http:', 'https:')
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/product/_tripadvisor";

.tripadvisor-container {
  border: none;
  padding: 60px 40px 60px 40px;

  @media (max-width: theme('screens.md')) {
    padding: 30px 18px 30px 18px;
  }

  .tripadvisor-title {
    font-size: 1.35rem;
  }
}
</style>
